module.exports = __webpack_public_path__ + "img/bg1.1d8fcc7c.png";